import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoreButton } from '../../../_core/components/_ui/core-button';
import { FamilyWithSurveyDto } from '@families-link/shared';
import { format } from 'date-fns';
import { buttonHeaderStyles } from '../../../_core/styles';

export type ManualEditingSurveyProps = {
	currentFamilyWithSurvey?: FamilyWithSurveyDto;
	handleOnManualEditing(f?: FamilyWithSurveyDto): Promise<void>;
};

export const ManualEditingSurvey: FC<ManualEditingSurveyProps> = (props) => {
	const { handleOnManualEditing, currentFamilyWithSurvey } = props;

	const [t] = useTranslation();

	const openSurveyManualEditingLink = () => {
		handleOnManualEditing(currentFamilyWithSurvey);
	};

	return (
		<Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
			<Typography variant="h2" sx={{ fontSize: '16px', fontWeight: 500, my: '24px' }}>
				{t('surveys.survey-results')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					flexGrow: 1,
					flexWrap: 'wrap',
					margin: 'auto',
					gap: 4,
				}}
			>
				<Typography variant="h3" sx={{ fontSize: '16px', fontWeight: 500 }}>
					{t('surveys.manual-editing-title')}
				</Typography>
				<Box sx={{ width: '65%', textAlign: 'center', marginY: '8px' }}>
					<Typography variant="body1" sx={{ fontSize: '14px' }}>
						{t('surveys.manual-editing-description')
							.replace(':SurveyTemplateName', currentFamilyWithSurvey?.surveyTemplate?.title ?? '')
							.replace(
								':SendDate',
								currentFamilyWithSurvey?.surveySendData
									? format(new Date(currentFamilyWithSurvey?.surveySendData), 'dd MMM yyyy')
									: ''
							)}
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<CoreButton onClick={openSurveyManualEditingLink} sx={buttonHeaderStyles}>
						{t('surveys.manual-editing-button')}
					</CoreButton>
				</Box>
			</Box>
		</Box>
	);
};
